<template>
    <div>
        <span>{{ $_.get(activity, 'actorUser.name') || 'Bilinmeyen Kullanıcı' }} kullanıcısı "{{ $_.get(activity, 'payload.taskTitle') || 'Bilinmeyen Görev' }}" adlı göreve {{ $_.get(activity, 'payload.attachmentCount') || 0 }} dosya ekledi: {{ ($_.get(activity, 'payload.attachments') || []).join(', ') || 'Dosyalar' }}.</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskAddedAttachment",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>
<style scoped lang="scss"></style>
